import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { View } from '../../../models/SearchResultTypes';
import { BasicField } from '../../tooltips/elements/BasicField';
import { LocationField } from '../../tooltips/elements/LocationField';
import { Name } from '../../tooltips/elements/Name';
import { Tags } from '../../tooltips/elements/Tags';
import { Timestamp } from '../../tooltips/elements/Timestamp';
import { ContentTooltipProps, getPersonalSpaceLink, getProjectLink } from '../../tooltips/TooltipHelper';
import { FeatureFlag, FeatureFlagService } from '../../../services/FeatureFlagService';
import { RelatedEntity } from '../../tooltips/elements/RelatedEntity';

export function ViewTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const viewContent = content as View;
  const projectLink = viewContent.project ? getProjectLink(viewContent.project.id, viewContent.project.name, urls) : undefined;
  const personalSpaceLink = getPersonalSpaceLink(urls);

  return (
    <div role={'tooltip'}>
      <Name name={viewContent.name} />
      {viewContent.tags && <Tags tags={viewContent.tags} />}
      {!FeatureFlagService.instance.getValue(FeatureFlag.personalSpaceEnabled) && projectLink && (
        <RelatedEntity label={Messages.column_location()} link={projectLink} icon={'folder_18px.svg'}></RelatedEntity>
      )}
      {FeatureFlagService.instance.getValue(FeatureFlag.personalSpaceEnabled) && (
        <LocationField
          locationType={viewContent.location?.type}
          projectLink={projectLink}
          personalSpaceLink={personalSpaceLink}
          contentOwnerId={viewContent.owner?.id}
        />
      )}
      {viewContent.hitsTotal !== undefined && <BasicField name={Messages.views()} value={viewContent.hitsTotal} />}
      {viewContent.modifiedTime && <Timestamp label={Messages.modified()} value={new Date(viewContent.modifiedTime)} />}
    </div>
  );
}
